import { List, Map, Set } from 'immutable';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  addArrayItem,
  bindMeta,
  blurField,
  collapseAllArrayItems,
  expandAllArrayItems,
  initializeArray,
  removeArrayItem,
  swapArrayItems,
  toggleArrayItem
} from '../../actions';
import { getDefinitions, makeArrayLengthSelector, makeValueSelector } from '../../selectors';
import ArrayField from './array-field';

const initialUiState = Map({
  arrayKeys: List(),
  collapsed: Set()
});

function mapStateToProps() {
  const lengthSelector = makeArrayLengthSelector();
  const valueSelector = makeValueSelector();

  return (state, props) => {
    const { ui, error } = valueSelector(state, props);

    return {
      definitions: getDefinitions(state, { formName: props.formName }),
      length: lengthSelector(state, props),
      ui: ui || initialUiState,
      error
    };
  };
}

const identity = (x) => x;
const mapDispatchToProps = (dispatch, { formName, path }) => {
  const bind = bindMeta(formName, path);
  return bindActionCreators(
    {
      swapArrayItems: bind(swapArrayItems),
      addArrayItem: bind(addArrayItem),
      removeArrayItem: bind(removeArrayItem),
      toggleArrayItem: bind(toggleArrayItem),
      expandAllArrayItems: bind(expandAllArrayItems),
      collapseAllArrayItems: bind(collapseAllArrayItems),
      initializeArray: bind(initializeArray),
      fieldAction: bind(identity),
      blurField: blurField.bind(null, formName, path)
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(ArrayField);
